module.exports = __webpack_public_path__ + "img/SK47231564.0a1736df.svg";